import React,{ useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import MenuBtn from './MenuBtn';
import MenuCircleBtnBacklite from './MenuCircleBtnBacklite';
import MenuCircleBtnOpenClose from './MenuCircleBtnOpenClose';

const ProductViewHeader = {
   borderBottom: "1px solid #c7c7c7",
   minHeight: "42px"
}

const openclose = {
   width: "36px",
   height: "36px !important"
}

const Btn = {
   borderRadius: "0px",
   background: 'transparent',
   border: 'none',
   boxShadow: 'none',
   marginLeft: '10px',
   color: '#000',
   textTransform: 'capitalize',
   marginRight: "25px"
}

const BtnIcon = {
   borderRadius: "0px",
   background: 'transparent',
   width: '36px',
   height: '36px'
}

const MenuSoftware = (props) => {
   return (
      <div className="Accordians">
         <Accordion style={{ borderRadius: "0px",borderBottom: '1px solid #CCCCCC' }} onChange={props.onChanged} expanded={props.expanded}>
            <AccordionSummary tabIndex="1" id="feature"
               expandIcon={<ExpandMoreIcon />} style={ProductViewHeader} onKeyPress={props.onSoftware} onClick={props.onSoftware} >
               <Typography className="accordion-headers AccordiansHeader" style={{ fontWeight: "700" }}>{window.finalLangues.software}</Typography>
            </AccordionSummary>
            <AccordionDetails tabIndex="1" id="iAutomation" aria-label="Intelligent Automation" onKeyPress={props.onIAutomationClicked} onClick={props.onIAutomationClicked}>
               <MenuBtn className="openclose" submenu={window.finalLangues.port1} source="./img/embedded.svg" />
            </AccordionDetails>

            <AccordionDetails tabIndex="1" id="cResiliency" aria-label="Cyber Resiliency" onKeyPress={props.onCResiliencyClicked} onClick={props.onCResiliencyClicked}>
               <MenuBtn submenu={window.finalLangues.port7} source="./img/openManage.svg" />
            </AccordionDetails>
         </Accordion>
      </div>
   );
}

export default MenuSoftware;